import { format } from "date-fns";
import { useFormik } from "formik";
import React from "react";
import { Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { fetchCustomers } from "../../Services/CustomerService";
import { useDispatch } from "react-redux";

const validationSchema = yup.object().shape({
  phone: yup
    .string()
    .matches(/^(3)([0-9]{9})$/, "Please enter a valid number!"),
  name: yup.string(),
});

export const Customers = () => {
  const [details, setDetails] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
    },
    validationSchema,
    onSubmit: (v) => {
      const payload = { ...v };
      for (const key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          const x = payload[key];
          if (!x) delete payload[key];
        }
      }
      if (payload.phone) payload.phone = `+92${payload.phone}`;
      const p = serialize(payload);
      if (p && p !== "?") {
        getCustomers(undefined, p);
      }
    },
  });

  const serialize = (obj) => {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p) && obj[p].trim()) {
        str.push(
          encodeURIComponent(p) + "=" + encodeURIComponent(obj[p].trim())
        );
      }
    return `?${str.join("&")}`;
  };

  const getCustomers = (url, params) => {
    setLoading(true);
    fetchCustomers(url, params).then(
      ({ data }) => {
        setDetails(data);
        setLoading(false);
        formik.resetForm();
      },
      (err) => {
        console.warn(err);
        toast.error("Something went wrong while fetching customer details.");
      }
    );
  };

  React.useEffect(() => {
    getCustomers();
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setPickupDate", payload: null });
    dispatch({ type: "setDeliveryDate", payload: null });
    dispatch({ type: "setAddresses", payload: null });
    dispatch({ type: "setDates", payload: null });
    dispatch({ type: "setOrderType", payload: null });
    dispatch({ type: "setCustomerId", payload: null });
    dispatch({ type: "setSelfPick", payload: null });
    dispatch({ type: "setProcessing", payload: null });
  }, []);
  return (
    <div className="container py-4" style={{ minHeight: "80vh" }}>
      <div className="row">
        <div className="col-12">
          <div className="card">
            {/* <div className="card-header bg-white">
              
            </div> */}
            <div className="card-body">
              <div className="d-flex flex-wrap align-items-center justify-content-between">
                <h3 className="mb-0 ">
                  Customers{" "}
                  {details ? (
                    <span className="roles-count">{details?.total}</span>
                  ) : null}
                </h3>
                <button
                  className="btn btn-dark text-primary"
                  onClick={() => {
                    navigate("/store/customers/add");
                  }}
                >
                  Create Customer
                </button>
              </div>
              <hr style={{ borderColor: "#282828" }} />
              {Boolean(details) && !loading ? (
                <>
                  <form
                    className="row align-items-end"
                    onSubmit={formik.handleSubmit}
                  >
                    <div className="col-lg-3 col-md-4 col-12">
                      {/* <Form.Label>Name</Form.Label> */}
                      <Form.Group controlId="name">
                        <Form.Control
                          type="text"
                          name="name"
                          style={{ padding: "0.375rem 0.75rem" }}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.name}
                          placeholder="Name"
                        />
                        {Boolean(formik.errors.phone) &&
                        formik.touched.phone ? (
                          <Form.Text className="text-white">
                            {formik.errors.phone}
                          </Form.Text>
                        ) : null}
                      </Form.Group>
                    </div>
                    <div className="col-lg-3 col-md-4 col-12">
                      {/* <Form.Label>Phone</Form.Label> */}
                      <Form.Group controlId="phone">
                        <InputGroup>
                          <InputGroup.Text>+92</InputGroup.Text>
                          <Form.Control
                            type="text"
                            name="phone"
                            placeholder="3xxxxxxxxx"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.phone}
                          />
                        </InputGroup>
                        {Boolean(formik.errors.phone) &&
                        formik.touched.phone ? (
                          <Form.Text className="text-danger">
                            {formik.errors.phone}
                          </Form.Text>
                        ) : null}
                      </Form.Group>
                    </div>
                    <div className="col-lg-3 col-md-4 col-12">
                      <button
                        className="btn btn-dark d-block text-primary"
                        style={{ height: "44px" }}
                        type="submit"
                        disabled={!formik.isValid}
                      >
                        Search
                      </button>
                      {Boolean(formik.errors.phone) && formik.touched.phone ? (
                        <Form.Text className="text-white">
                          {formik.errors.phone}
                        </Form.Text>
                      ) : null}
                    </div>
                  </form>
                  <hr
                    style={{
                      borderColor: "#282828",
                      marginBottom: !loading ? "0px" : "",
                    }}
                  />
                </>
              ) : null}
              {Boolean(details) && !loading ? (
                <div className="table-responsive">
                  <table className="table table-sm">
                    {details ? (
                      <caption>
                        <div className="w-100 d-flex align-items-center justify-content-between flex-wrap pt-3">
                          <nav aria-label="Page navigation example">
                            {details?.links?.length > 3 ? (
                              <ul className="pagination justify-content-end mb-0">
                                {details?.links?.map((link, index) => (
                                  <li
                                    className={`page-item ${
                                      link.active ? "active" : ""
                                    }`}
                                    key={index}
                                  >
                                    <span
                                      onClick={() => {
                                        if (!loading) {
                                          getCustomers(link.url);
                                        }
                                      }}
                                      className="page-link cursor-pointer"
                                      dangerouslySetInnerHTML={{
                                        __html: link.label,
                                      }}
                                    />
                                  </li>
                                ))}
                              </ul>
                            ) : null}
                          </nav>

                          <span>
                            Showing {details?.from} to {details?.to} of{" "}
                            {details?.total}
                          </span>
                        </div>
                      </caption>
                    ) : null}
                    <thead className="table-light">
                      <tr>
                        <th scope="col">S.NO</th>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Joined On</th>
                        <th scope="col">Total Order</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    {!loading ? (
                      <tbody>
                        {details?.data?.map((customer, i) => (
                          <tr key={`customer-row-${i}`}>
                            <td>{i + 1}</td>
                            <td>
                              {customer.f_name} {customer.l_name}
                            </td>
                            <td>{customer.email}</td>
                            <td>{customer.phone}</td>
                            <td>
                              {format(customer.created_at, "yyyy-MM-dd p")}
                            </td>
                            <td>{customer.laundry_orders_count}</td>
                            <td className="action-td">
                              <Link
                                className="btn btn-outline-secondary btn-sm me-1"
                                to={`./view/${customer.id}`}
                              >
                                View
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <div className="text-center w-100">
                        <Spinner variant="primary" />
                      </div>
                    )}
                  </table>
                </div>
              ) : (
                <div className="text-center w-100">
                  <Spinner variant="primary" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
